import { makeAutoObservable } from 'mobx';
import {
  clearPersistedStore,
  getPersistedStore,
  hydrateStore,
  isHydrated,
  makePersistable,
} from 'mobx-persist-store';

export const defaultDateFormat = 'dd/MM/yyyy';
export const defaultTimeFormat = 'HH:mm';
export const defaultTimezone = 'UTC';

class DateFormatState {
  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: 'date-format',
      properties: [
        'preferredDateFormat',
        'preferredTimeFormat',
        'preferredTimezone',
      ],
      storage: window.localStorage,
    });
  }

  public preferredDateFormat: string = defaultDateFormat;

  public preferredTimeFormat: string = defaultTimeFormat;

  public preferredTimezone: string = defaultTimezone;

  get isHydrated() {
    return isHydrated(this);
  }

  async hydrateStore() {
    await hydrateStore(this);
  }

  async clearStoredDate() {
    await clearPersistedStore(this);
  }

  async getStoredData() {
    return getPersistedStore(this);
  }
}

export const dateFormatState = new DateFormatState();
